module.exports = __webpack_public_path__ + "static/media/logo_qr03.3e2dc80c.png";